import React from 'react';
import { NoRowsOverlay } from './NoRowsOverlay';

export function NoObjectsFoundOverlay() {
	return <NoRowsOverlay text="No objects found" />;
}
